import { TableHeadersType } from "../tableHeadersType";

export const JOBS_TABLE_HEADER:TableHeadersType[]=[
    {
        "label":"JOB DETAILS",
        "value":"job_id",
        "defaultChecked":true,
        "checked":true
    },
    {
        "label":"CLIENT",
        "value":"client",
        "defaultChecked":true,
        "checked":true
    },
    {
        "label":"TARGET END DATE",
        "value":"target_end_date",
        "defaultChecked":true,
        "checked":true
    },
    {
        "label":"JOB DESCRIPTION",
        "value":"job_description",
        "defaultChecked":true,
        "checked":true
    },
    {
        "label":"CURRENTLY RESPONSIBLE",
        "value":"currently_responsible",
        "defaultChecked":true,
        "checked":true
    },
    {
        "label":"JOB MANAGER",
        "value":"job_manager",
        "defaultChecked":true,
        "checked":true
    },
    {
        "label":"Updated By",
        "value":"updated_by",
        "defaultChecked":true,
        "checked":true
    },
    {
        "label":"STATUS",
        "value":"job_status",
        "defaultChecked":true,
        "checked":true
    },
    // {
    //     "label":"ACTION",
    //     "value":"action",
    //     "defaultChecked":true,
    //     "checked":true
    // },
]

export const ALL_OPEN_CHECKLIST_HEADER = [
    {
      label: "Title",
      value: "title",
      width: "300px",
    },
    {
      label: "Remark",
      value: "comment",
    },
    {
      label: "Last Modified",
      value: "last_modified",
      width: "150px"
    },
    {
      label: "Approved",
      value: "approved"
    },
    {
      label: "Document",
      value: "attach_link",
    },
  ];